import { render, staticRenderFns } from "./SendFriendRequest.vue?vue&type=template&id=e9aa7c6a"
import script from "./SendFriendRequest.vue?vue&type=script&lang=js"
export * from "./SendFriendRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports